<script>
export default {
  data () {
    return {
      userIdSet: [],
      userNameSet: []
    }
  },
  methods: {
    loadUser () {
      this.$axios
        .get('/search-user')
        .then((res) => {
          const result = res.data.list
          const userIdSet = new Set()
          const userNameSet = new Set()
          result.forEach((x) => {
            userIdSet.add(x.user_id)
            userNameSet.add(x.user_name)
          })
          this.userIdSet = [...userIdSet]
          this.userNameSet = [...userNameSet]
          sessionStorage.setItem('userIdSet', JSON.stringify(this.userIdSet))
          sessionStorage.setItem('userNameSet', JSON.stringify([...this.userNameSet]))
        })
        .catch((e) => {
          console.log(e)
        })
    },
    refreshUserAutocompleteList () {
      this.userIdSet = JSON.parse(sessionStorage.getItem('userIdSet'))
      this.userNameSet = JSON.parse(sessionStorage.getItem('userNameSet'))
    },
    getUserIdSet () {
      return JSON.parse(sessionStorage.getItem('userIdSet'))
    },
    getUserNameSet () {
      return JSON.parse(sessionStorage.getItem('userNameSet'))
    },
    margeUserIdSet (value) {
      const newUserIdSet = Array.isArray(value) ? [...value] : [value]
      const userIdSet = [...new Set([...JSON.parse(sessionStorage.getItem('userIdSet')),
        ...newUserIdSet])].sort()
      sessionStorage.setItem('userIdSet', JSON.stringify([...userIdSet]))
    },
    margeUserNameSet (value) {
      const newUserNameSet = Array.isArray(value) ? [...value] : [value]
      const userNameSet = [...new Set([...JSON.parse(sessionStorage.getItem('userNameSet')),
        ...newUserNameSet])].sort()
      sessionStorage.setItem('userNameSet', JSON.stringify([...userNameSet]))
    }
  }
}
</script>
